/**
 * @generated SignedSource<<a5775e1a05c777e3b89673cd509a6cd2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type widgetNewsletterArticleArticle$data = {
  readonly relatedNewsletters: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"helpersMassageToNewsletterItemNewsletter">;
  } | null> | null;
  readonly " $fragmentType": "widgetNewsletterArticleArticle";
};
export type widgetNewsletterArticleArticle$key = {
  readonly " $data"?: widgetNewsletterArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"widgetNewsletterArticleArticle">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "text",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "widgetNewsletterArticleArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Newsletter",
      "kind": "LinkedField",
      "name": "relatedNewsletters",
      "plural": true,
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "helpersMassageToNewsletterItemNewsletter",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "alternativeName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FormattedValue",
              "kind": "LinkedField",
              "name": "description",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FormattedValue",
              "kind": "LinkedField",
              "name": "summary",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FormattedValue",
              "kind": "LinkedField",
              "name": "homepageDescription",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};
})();

(node as any).hash = "f7cdf64e0f9902bfaa80624ce4233326";

export default node;
